import { Entity } from '@/store/shared/entity'

export default class Customer extends Entity<number>{
    name:string;
    bankCharges:number;
    address:string;
    prepaymentPercentage:number;
    paymentDays:number;
    customerBusinessGroupIdList:Array<any> = [];
    customerBusinessGroupIds:string;
}